import {NgModule} from '@angular/core';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {RouterModule} from '@angular/router';
import {TranslateModule} from '@ngx-translate/core';

import {OverlayModule} from '@angular/cdk/overlay';
import {MatCardModule} from '@angular/material/card';
import {
  FormatDescriptionPipe,
  Q9HtmlEncoderPipe,
  Q9TrackDirective
} from '@q9elements/ui-kit/common';
import {
  BlurWrapperComponent,
  ButtonToggleGroupModule,
  IconButtonComponent,
  LinkButtonComponent,
  NotificationsModule,
  PrimaryButtonComponent,
  TagComponent
} from '@q9elements/ui-kit/components';
import {SharedModule} from '../shared/shared.module';
import {SidebarWrapperModule} from '../sidebar/sidebar-wrapper.module';
import {ImpactAssessmentComponent} from './impact-assessment.component';
import {ImpactTreeToolbarComponent} from './impact-tree/impact-tree-toolbar/impact-tree-toolbar.component';
import {ImpactTreeComponent} from './impact-tree/impact-tree.component';
import {ImpactAssessmentTreeService} from './services/impact-analysis-tree.service';
import {ImpactAssessmentDaoService} from './services/impact-assessment-dao.service';

/** Components */

/** Services */

@NgModule({
  imports: [
    RouterModule,
    NotificationsModule,
    SharedModule,
    SidebarWrapperModule,
    Q9TrackDirective,
    TranslateModule,
    IconButtonComponent,
    MatCardModule,
    OverlayModule,
    TagComponent,
    LinkButtonComponent,
    ButtonToggleGroupModule,
    Q9HtmlEncoderPipe,
    FormatDescriptionPipe,
    MatSnackBarModule,
    PrimaryButtonComponent,
    BlurWrapperComponent
  ],
  declarations: [ImpactAssessmentComponent, ImpactTreeComponent, ImpactTreeToolbarComponent],
  providers: [ImpactAssessmentTreeService, ImpactAssessmentDaoService],
  exports: [ImpactAssessmentComponent]
})
export class ImpactAssessmentModule {}
